import React, { useEffect, useState } from 'react';
import { get } from '../../utils/api'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { isMobile } from '../../config';
import HeaderComponents from '../../components/Header/HeaderComponents';
import ProdSdBnComp from '../../components/SideBanner/ProdSdBnComp';
import PrdDtlDscr from '../../components/Product/PrdDtlDscr';
import PrdDtlImg from '../../components/Product/PrdDtlImg';
import PrdDtlFile from '../../components/Product/PrdDtlFile';
import PrdDtlSpec from '../../components/Product/PrdDtlSpec';
import PrdDtlItem from '../../components/Product/PrdDtlItem';

import sty from './ProdDetailPage.module.css';

const ProdDetailPage = () => {

  const [ prdDetail, setPrdDetail ] = useState([]);
  const [ prdFile, setPrdFile ] = useState([]);
  const [ prdImg, setPrdImg ] = useState([]);
  const [ prdSpec, setPrdSpec ] = useState([]);
  const [ prdItem, setPrdItem ] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  const idx = searchParams.get("idx");
  const listIdx = searchParams.get("list");

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 327);
    };
  
    setTimeout(scrollToTop, 0);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const detailResponse = await get(`/product/detail?idx=${idx}`);
        setPrdDetail(detailResponse);

        const imageResponse = await get(`/product/img?idx=${idx}`);
        setPrdImg(imageResponse);

        const fileResponse = await get(`/product/file?idx=${idx}`);
        setPrdFile(fileResponse);

        const specResponse = await get(`/product/spec?idx=${idx}`);
        setPrdSpec(specResponse);

        const itemResponse = await get(`/product/item?idx=${idx}`);
        setPrdItem(itemResponse);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();

  }, [location]);

  const handleImageClick = (clickedImgSeq, clickedImgPath, clickedImgSort) => {

    const mainImgIndex = prdImg.findIndex(img => img.IMG_SORT === 0);
  
    setPrdImg(prevImages => {
      const updatedImages = [...prevImages];
      updatedImages[mainImgIndex] = {
        IMG_SEQ: clickedImgSeq,
        IMG_PATH: clickedImgPath,
        IMG_SORT: 0
      };
      updatedImages[clickedImgSort] = {
        IMG_SEQ: prevImages[mainImgIndex].IMG_SEQ,
        IMG_PATH: prevImages[mainImgIndex].IMG_PATH,
        IMG_SORT: clickedImgSort
      };
      return updatedImages;
    });
  };

  const filledImg = new Array(5).fill(null).map((_, index) => prdImg[index] || {});
  
  const filledItem = new Array(4).fill(null).map((_, index) => prdItem[index] || {});

  const handleGoBack = () => {
    navigate(`/product/list?list=${listIdx}&pageIdx=1`, { state: { fromDetailPage: true } });
  };

  const handleInquiry = () => {
    navigate(`/support/inquiry/1`, {});
  }

  return (
    <div>
        <HeaderComponents pageKey="product" />
        <div className="inner-container">
          <ProdSdBnComp location={location}/>
          <div className="prod-list-div" style={{minHeight:'650px'}}>
            
            {isMobile() ? (
                <>
                <div className={`mt-50 ${sty.mainImgDiv}`}>
                  <PrdDtlImg
                    imgSeq={filledImg[0]?.IMG_SEQ}
                    imgPath={filledImg[0]?.IMG_PATH}
                    imgSort={filledImg[0]?.IMG_SORT || 0}
                  />
                </div>
                <div className='prod-line-detail'></div>
                {prdDetail && prdDetail.map((pd, index) => (
                  <PrdDtlDscr key={index} dtlName={pd.DETAIL_NAME} dtlDscr={pd.DETAIL_DESCRIPTION} />
                ))}
                </>
              ) : (
                <>
                <div className='prod-line-detail mt-70'></div>
                <div>
                  {prdDetail && prdDetail.map((pd, index) => (
                    <PrdDtlDscr key={index} dtlName={pd.DETAIL_NAME} dtlDscr={pd.DETAIL_DESCRIPTION} />
                  ))}
                  <div className={sty.mainImgDiv}>
                    <PrdDtlImg
                      imgSeq={filledImg[0]?.IMG_SEQ}
                      imgPath={filledImg[0]?.IMG_PATH}
                      imgSort={filledImg[0]?.IMG_SORT || 0}
                    />
                  </div>
                </div>
                </>
              )
            }
            
            <div className={sty.dtlFileDiv}>
              {prdFile && prdFile.map((pdf, index) => (
                <PrdDtlFile key={index} fileSeq={pdf.FILE_SEQ} filePath={pdf.FILE_PATH} fileType={pdf.FILE_TYPE} />
              ))}
            </div>

            <div className={`prod-line ${sty.prodLine}`}></div>
            
            <div className={sty.dtlSubImgDiv} draggable>
              {filledImg.slice(1).map((img, index) => (
                <PrdDtlImg
                  key={index}
                  imgSeq={img.IMG_SEQ}
                  imgPath={img.IMG_PATH}
                  imgSort={img.IMG_SORT || index}
                  handleImageClick={handleImageClick}
                />
              ))}
            </div>

            {prdSpec.length === 0 ? (
              <></>
            ):(
              <>
              <div className='prod-line-detail'></div>
              <div className={sty.dtlTitle}>제품 스펙</div>
              <table className={sty.tableWrap} draggable>
                {isMobile() ? (
                <tbody>
                  {prdSpec && prdSpec.map((pds, index) => (
                    <tr key={pds.SPEC_SEQ} className={sty.specTr}>
                      <PrdDtlSpec
                        specSeq={pds.SPEC_SEQ}
                        specName={pds.SPEC_NAME}
                        specDscr={pds.SPEC_DESCRIPTION}
                        specType={pds.SPEC_TYPE}
                        totalSpecs={prdSpec.length}
                        index={index}
                      />
                    </tr>
                  ))}
                </tbody>
                ):(
                <tbody>
                  {prdSpec && prdSpec.map((pds, index) => (
                    index % 2 === 0 && (
                      <>
                      <tr key={pds.SPEC_SEQ} className={sty.specTr}>
                        <PrdDtlSpec
                          specSeq={pds.SPEC_SEQ}
                          specName={pds.SPEC_NAME}
                          specDscr={pds.SPEC_DESCRIPTION}
                          specType={pds.SPEC_TYPE}
                          totalSpecs={prdSpec.length}
                          index={index}
                        />
                        {prdSpec[index + 1] && (
                          <PrdDtlSpec
                            specSeq={prdSpec[index + 1].SPEC_SEQ}
                            specName={prdSpec[index + 1].SPEC_NAME}
                            specDscr={prdSpec[index + 1].SPEC_DESCRIPTION}
                            specType={prdSpec[index + 1].SPEC_TYPE}
                            totalSpecs={prdSpec.length}
                            index={index + 1}
                          />
                        )}
                      </tr>
                      </>
                    )
                  ))}
                </tbody>
                )}
              </table> 
              </>
            )}

            {prdItem.length === 0 ? (
              <></>
            ):(
              <>
              <div className='prod-line-detail'></div>
              <div className={sty.dtlTitle}>관련 상품</div>
              <div className={`${sty.dtlItemDiv}`} draggable>
                {filledItem.map((item, index) => (
                  <PrdDtlItem
                    key={index}
                    itemSeq={item.ITEM_SEQ}
                    itemInfoName={item.INFO_NAME}
                    itemPath={item.INFO_IMG_PATH}
                    itemDivName={item.DIV_2_NAME}
                    itemLinkSeq={item.LINK_INFO_SEQ}
                    itemSort={item.ITEM_SORT || index}
                    itemDiv2={item.DIV_2_SEQ}
                  />
                ))}
              </div>
              </>
            )}

            <div className='mt-50 mb-65 text-center' draggable>
              <button className='back-btn' onClick={handleGoBack}>목록으로</button>&nbsp;&nbsp;&nbsp;&nbsp;
	      <button className='inquiry-btn' onClick={handleInquiry}>문의하기</button>
            </div>
            
          </div>
        </div>
    </div>
  );
};

export default ProdDetailPage;
